import { useRecoilValue } from 'recoil';

import { customerDeliverySelector } from '../../states/shipment';
import DeliveryHistoryItem from '../HistoryItem';

function DeliveryHistory() {
  const shipments = useRecoilValue(customerDeliverySelector);

  return (
    <div style={{ height: 'calc(100% - 4px)', width: '95%', position: 'relative', padding: 0 }}>
      <div style={{ position: 'absolute', padding: '10px 0', width: '100%' }}>
        {shipments?.map((shipment) => <DeliveryHistoryItem showCustomer={true} key={shipment.id} shipment={shipment} />)}
      </div>
    </div>
  );
}

export default DeliveryHistory;
